import { Shark } from "shark-mvc";
import NousCoreModel from "./NousCoreModel";
// import moment from "moment";

class UserPermission extends NousCoreModel {
	static STATUS_ACTIVE = 1;
	static STATUS_INACTIVE = 2;

	referenceGuid = "";
	settings = {};
	type = "";
	userGuid = "";

	__inherited = false;

	constructor (data) {
		super();
		
		if (data) {
			this.import(data);
		}
	}

	export () {
		const exportData = super.export();

		exportData.settings = this.exportObjectField("settings");

		return exportData;
	}

	hasPermission (permissionName) {
		return this.settings.permissions.includes(permissionName);
	}

	// import (data, options) {
	// 	super.import(data, options);



	// 	// this.parseType();
	// }

	// // parseType () {
	// // 	switch (this.type) {
	// // 		case CalendarEvent.TYPE_ENTER:
	// // 			this.__typeLabel = "Ingresso";
	// // 			this.__type_enter = true;
	// // 			break;
	// // 		case CalendarEvent.TYPE_EXIT:
	// // 			this.__typeLabel = "Uscita";
	// // 			this.__type_exit = true;
	// // 			break;
	// // 	}
	// // }
}

Shark.registerModel("UserPermission", UserPermission);

export default UserPermission;